import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useState } from 'react';
import { getProperties, sellerGetProfile } from '../api';
import List from '../components/core/List';
import Wrapper from '../components/core/Wrapper';
import Pagination from '../components/Pagination/Pagination';
import { Property } from '../components/Property/Property';
import { getProfilePic } from '../helpers/images';
import { getLocaleDate } from '../helpers/time';
import styles from './Profile.module.scss';

export default function Profile(props: any) {
  const profileId = props.match.params.id;
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState<any>();

  useEffect(() => {
    sellerGetProfile(profileId)
      .then((response) => setUser(response.data.data))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <Wrapper
      contentProps={{ className: styles.content }}
      subHeader={{ title: 'PERFÍL' }}
    >
      {isLoading ? (
        <CircularProgress style={{ marginTop: 30, marginLeft: 20 }} />
      ) : (
        user && (
          <div className={styles.profileInfoContainer}>
            <img src={getProfilePic(user.photo)} />
            <h2>{`${user.name} ${user.lastName || ''}`}</h2>
            <p className={styles.smallDetail}>
              {user.isVerified ? (
                <>
                  <i className="fonticons fonticons-checked" />
                  <span> Usuario Verificado</span>
                </>
              ) : (
                <span> No Verificado</span>
              )}
            </p>
            <p className={styles.smallDetail}>
              Miembro desde {getLocaleDate(user.createdAt)}
            </p>
            <p className={styles.smallDetail}>{user.sellerType}</p>
            <p>
              <i className="fonticons fonticons-star" />
              <i className="fonticons fonticons-star" />
              <i className="fonticons fonticons-star" />
              <i className="fonticons fonticons-star" />
            </p>

            {user.proffessionalDescription && (
              <p className={styles.description}>
                {user.proffessionalDescription}
              </p>
            )}
            <a href={`mailto:${user.email}`}>
              <i className="fonticons fonticons-email" />
              <span> {user.email}</span>
            </a>
            {user.phone && (
              <p>
                <i className="fonticons fonticons-phone" />
                <span> {user.phone}</span>
              </p>
            )}
          </div>
        )
      )}
      <div className={styles.propertiesContainer}>
        <Pagination
          customQueryParams={{
            filters: { user: profileId },
          }}
          apiFn={getProperties}
          render={(properties, isLoading, error, paginationEl) =>
            isLoading ? (
              <CircularProgress style={{ marginTop: 30, marginLeft: 20 }} />
            ) : error ? (
              <p>Ocurrió un error</p>
            ) : (
              <>
                <h2>Propiedades de {user?.name || ''}</h2>
                <List>
                  {properties?.map(
                    (item: any) =>
                      item && <Property key={item.id} property={item} />
                  )}
                </List>
                {paginationEl}
              </>
            )
          }
        />
      </div>
    </Wrapper>
  );
}
